<template>
  <Navbar />
  <Header v-bind:title="title" />

  <div class="backToList">
    <router-link to="/surveys">
      <font-awesome-icon icon="fa-solid fa-angles-left" />問卷調查
    </router-link>
  </div>

  <section v-if="article" class="sec-detail news-detail">
    <h2 class="text-info">{{ article.title }}</h2>
    <p class="post-time">
      <font-awesome-icon icon="fa-regular fa-clock" /> Post on
      {{ formattedTimestamp(article.timestamp) }}
    </p>
    <div v-html="article.content" />
    <p> {{ article.title_content }} </p>

  </section>
  <section v-else class="sec-detail news-detail">Loading...</section>

  <Footer />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import formatted from "@/mixin/formatted";

export default {
  name: "App",
  components: { Navbar, Header, Footer },
  props: ["id"],
  mixins: [formatted],

  data() {
    return {
      title: "問卷調查",
      article: null,
    };
  },

  mounted() {
    fetch("https://oir.nccu.edu.tw/codeigniter/api/result/" + this.id)
      .then((respond) => respond.json())
      .then((data) => {
        console.log(data);
        this.article = data;
      })
      .catch((err) => console.log(err.message));
  },
};
</script>

<style></style>
